// import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputField } from "../../../../Components/formElements/InputField";

// const EwayBillModal = ({ show, onHide, erfData }) => {
  const EwayBillModal = ({ show, onHide, erfData, ewayData, setEwayData }) => {


  // const [ewayData, setEwayData] = useState({
  //   transportId: "",
  //   transportMode: "Road",
  //   transporterName: "",
  //   transportDistance: "",
  //   transportDocNo: "",
  //   transportDocDate: "",
  //   vehicleNo: "",
  //   vehicleType: "Regular",
  // });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setEwayData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>SE Details FORM</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* Top Static Details */}
        <Row>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
            <InputField
              label="ERF No"
              className="inputBox"
              value={erfData?.documentNumber}
              disabled
            />
          </Col>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
            <InputField
              label="Billing Name"
              className="inputBox"
              value={erfData?.customerName}
              disabled
            />
          </Col>

          <Col lg={6} md={12} className="commTopButtonRightLeftPadding">
            <InputField
              label="Address"
              className="inputBox"
              value={erfData?.deliveryAddress}
              disabled
            />
          </Col>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
            <InputField
              label="Pincode"
              className="inputBox"
              value={erfData?.deliveryPinCode}
              disabled
            />
          </Col>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
            <InputField
              label="Total Value"
              className="inputBox"
              value={erfData?.grossValue}
              disabled
            />
          </Col>

          <Col lg={2} md={4} className="commTopButtonRightLeftPadding">
            <InputField
              label="CGST"
              className="inputBox"
              value={erfData?.cgst || 0}
              disabled
            />
          </Col>

          <Col lg={2} md={4} className="commTopButtonRightLeftPadding">
            <InputField
              label="SGST"
              className="inputBox"
              value={erfData?.sgst || 0}
              disabled
            />
          </Col>

          <Col lg={2} md={4} className="commTopButtonRightLeftPadding">
            <InputField
              label="IGST"
              className="inputBox"
              value={erfData?.igst || 0}
              disabled
            />
          </Col>

        </Row>

        <hr />

        {/* Transport Details */}
        <Row>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
            <InputField
              label="Transport Id"
              className="inputBox"
              name="transportId"
              value={ewayData.transportId}
              onChange={handleChange}
            />
          </Col>
<Col lg={3} md={6} className="commTopButtonRightLeftPadding">

  <label className="form-label">Transport Mode</label>

  <select
    className="form-control inputBox"
    name="transportMode"
    value={ewayData.transportMode}
    onChange={handleChange}
  >
    <option value="Road">Road</option>
    <option value="Rail">Rail</option>
    <option value="Air">Air</option>
    <option value="Ship">Ship</option>
  </select>

</Col>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
            <InputField
              label="Transporter Name *"
              className="inputBox"
              name="transporterName"
              value={ewayData.transporterName}
              onChange={handleChange}
            />
          </Col>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding d-flex align-items-end">
            <div style={{ width: "100%" }}>
              <InputField
                label="Transport Distance *"
                className="inputBox"
                name="transportDistance"
                type="number"
                value={ewayData.transportDistance}
                onChange={handleChange}
              />
              {/* <span
                style={{ cursor: "pointer", fontSize: "12px", color: "blue" }}
              >
                Get Distance
              </span> */}
              <span
  style={{ cursor: "pointer", fontSize: "12px", color: "blue" }}
  onClick={() =>
    window.open(
      "https://gstserver.com/tools/distance-between-pin-codes/",
      "_blank"
    )
  }
>
  Get Distance
</span>
            </div>
          </Col>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
            <InputField
              label="Transport Doc No"
              className="inputBox"
              name="transportDocNo"
              value={ewayData.transportDocNo}
              onChange={handleChange}
            />
          </Col>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
            <InputField
              label="Transport Doc Date *"
              name="transportDocDate"
              className="inputBox"
              type="date"
              value={ewayData.transportDocDate}
              onChange={handleChange}
            />
          </Col>

          <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
            <InputField
              label="Vehicle No *"
              className="inputBox"
              name="vehicleNo"
              value={ewayData.vehicleNo}
              onChange={handleChange}
            />
          </Col>

        <Col lg={3} md={6} className="commTopButtonRightLeftPadding">
  
  <label className="form-label">Vehicle Type</label>

  <select
    className="form-control inputBox"
    name="vehicleType"
    value={ewayData.vehicleType}
    onChange={handleChange}
  >
    <option value="">Select Vehicle Type</option>
    <option value="Regular">Regular</option>
    <option value="ODC">ODC</option>
  </select>

</Col>

        </Row>

        {/* <Row className="mt-4">
          <Col className="text-end">
            <button className="btnTable btn-danger me-2" onClick={onHide}>
              Cancel
            </button>
            <button className="btnTable">
              Generate Ewaybill_json
            </button>
          </Col>
        </Row> */}
        <Row className="mt-4">
          <Col xs={12} md={4} lg={4} className="headerButtonAlign">
            {/* <Col className="d-flex justify-content-start"> */}
            <Col
              xs={4}
              md={2}
              lg={2}
              className="d-flex justify-content-between"
            >
              <button className="btnTable btn-danger" onClick={onHide}>
                Cancel
              </button>
            </Col>
            <Col
              xs={4}
              md={2}
              lg={2}
              className="d-flex justify-content-between"
            >
              {/* <button className="btnTable btn-danger me-2" onClick={onHide}>
              Cancel
            </button> */}
              <button className="btnTable" 
              // onClick={handleUpdate}
              onClick={onHide}
              >
                              Save SE Details

              </button>
            </Col>
          </Col>
        </Row>

      </Modal.Body>
    </Modal>
  );
};

export default EwayBillModal;